<template>
  <div class="gestion-tab">
    <!-- Gestion tab -->
    <v-layout align-center>
      <v-flex sm2>
        <!-- <p>Applicateur: {{ applicatorFullname }}</p> -->
        <v-select :items="applicatorsList" :value="project.applicator_id" item-value="id" :item-text="applicatorFullname" label="Applicateur principal"></v-select>
      </v-flex>
      <v-flex style="padding-left:3em;" sm2>
        <v-btn @click="swapApplicators"><v-icon dark>mdi-swap-horizontal</v-icon>Intervertir</v-btn>
      </v-flex>
      <v-flex sm4>
        <v-select :items="applicatorsList" :value="project.applicator_supp_id" item-value="id" :item-text="applicatorFullname" label="Suppléant"></v-select>
      </v-flex>
    </v-layout>
    <v-layout justify-space-between>
      <v-flex sm4 style="position:relative;">
        <ArticlesTable
          type="MANAGEMENT"
          :product-model="project.product_model"
          show-select
        />

        <v-layout>
          <v-flex>
            <v-text-field
              v-model="project.miscellaneous_label"
              outlined
              hide-details
              label="Nomenclature divers"
              class="mt-4 mb-4 mr-4"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="project.miscellaneous_amount_ht"
              outlined
              hide-details
              label="Nomenclature divers prix HT"
              class="mt-4 mb-4"
              type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm8 ml-8>
        <v-layout justify-space-between mb-4>
          <v-flex sm5>
            <v-select
              :items="devices"
              item-text="label"
              item-value="id"
              v-model="project.device_id"
              label="Type"
              filled
              clearable
            ></v-select>
            <v-select
              v-model="project.operation_id"
              :items="operations"
              item-text="label"
              item-value="id"
              label="Opération"
              filled
              clearable
            ></v-select>
            <v-select
              v-model="project.bracket_id"
              :items="brackets"
              item-text="label"
              item-value="id"
              label="Support"
              filled
              clearable
              persistent-hint
              hint="S1 Achat"
            ></v-select>
            <v-select
              v-model="project.agency_id"
              :items="agencies"
              item-text="name"
              item-value="id"
              label="Agence"
              filled
              clearable
            ></v-select>
            <v-select
              v-model="project.manpower_id"
              :items="techniciansItems"
              item-text="fullname"
              item-value="id"
              label="Technicien"
              filled
              clearable
            ></v-select>

            <h4 class="mb-2 mt-8">Calculé automatiquement :</h4>
            <v-text-field
              :value="project.total_amount_ht_worksheet | currency"
              outlined
              hide-details
              label="Total HT Feuile de travail"
              class="mb-4"
              readonly
            ></v-text-field>
            <v-text-field
              :value="project.total_amount_ht_lomaco_quotation | currency"
              readonly
              outlined
              hide-details
              label="Total HT Devis LOMACO"
              class="mb-4"
            ></v-text-field>
            <v-text-field
              :value="project.total_amount_ht_lomaco_invoice | currency"
              outlined
              hide-details
              label="Total HT Facture LOMACO"
              class="mb-4"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex sm6 ml-4>
            <v-text-field
              v-model="project.estimated_finishing_time"
              outlined
              hide-details
              label="Temps Finition estimé"
              class="mb-4"
              readonly
              disabled
            ></v-text-field>
            <v-text-field
              type="number"
              v-model="project.real_finishing_time_in_float"
              outlined
              hide-details
              label="Temps Finition réel"
              placeholder="T1"
              class="mb-4"
            ></v-text-field>
            <v-text-field
              :value="technician.hourly_cost | currency"
              outlined
              label="Coût Horaire"
              placeholder="S0"
              readonly
            ></v-text-field>
            <v-text-field
              :value="project.total_manpower | currency"
              readonly
              outlined
              hide-details
              label="Main d’oeuvre totale"
              class="mb-4"
            ></v-text-field>
            <v-text-field
              v-model="project.manufactured_cost"
              outlined
              hide-details
              label="Cout fabriqué"
              placeholder="C1"
            ></v-text-field>
            <v-dialog v-model="dialog_date_cost" width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="project.cost_calculation_date | dateFormat"
                  label="Date calcul coût"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                v-model="project.cost_calculation_date"
              ></v-date-picker>
            </v-dialog>

            <v-textarea
              filled
              v-model="project.workshop_comment"
              label="Commentaire ATELIER"
              rows="5"
              hide-details
              class="mt-2"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "GestionTab",
    components: {
      // InputNumber: () => import("@/components/InputNumber"),
      ArticlesTable: () => import("./ArticlesTable")
    },
    props: {
      project: {
        type: Object,
        required: true
      },

      // Settings
      devices: {
        type: Array,
        default: () => []
      },
      operations: {
        type: Array,
        default: () => []
      },
      brackets: {
        type: Array,
        default: () => []
      },
      agencies: {
        type: Array,
        default: () => []
      },
      technicians: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        headers: [
          {
            text: "Traiter",
            sortable: true,
            value: "patient"
          },
          {
            text: "Lpp",
            sortable: true,
            value: "type"
          },
          {
            text: "Qté",
            sortable: true,
            value: "created_at"
          },
          {
            text: "Total HT",
            sortable: true,
            value: "transferred_at"
          }
        ],

        dialog_date_cost: false,
        dialog: false
      };
    },
    computed: {
      techniciansItems() {
        return this.technicians.map(item => {
          const firtsname = item.firstname || "";
          const lastname = item.name || "";

          item.fullname = `${lastname} ${firtsname}`;
          return item;
        });
      },

      technician() {
        if (this.project.manpower_id) {
          return this.technicians.find(
            technician => technician.id === this.project.manpower_id
          );
        }

        return {};
      },

      patientFullname() {
        const fullname =
          this.project.patient.lastname + " " + this.project.patient.firstname;
        return fullname.toUpperCase();
      },

      applicatorsList() {
        return this.$store.state.users.users.filter(x => x.role == "APPLICATOR")
      }
    },
    methods: {
      applicatorFullname(applicator) {
        const fullname =
          applicator.lastname +
          " " +
          applicator.firstname;
        return fullname.toUpperCase();
      },
      swapApplicators() {
        const app_id = this.project.applicator_id;
        const app_supp_id = this.project.applicator_supp_id;
        this.project.applicator_supp_id = app_id;
        this.project.applicator_id = app_supp_id;

      }
    },
    mounted() {
      console.log("hoy");
      this.$store.dispatch("users/fetchUsers", null);
    }
  };
</script>

<style lang="scss" scoped>
  .gestion-tab {
    .btn-container {
      .v-btn {
        background-color: #880e4f !important;
        color: #fff;
      }
    }
  }
</style>
